// components/LoadingScreen.js //
import React from "react";
import Logo from "../assets/RTSLOGO.png"; // Riviera Tech Solutions Logo

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black z-50">
      <img
        src={Logo}
        alt="Riviera Tech Logo"
        className="h-80 w-80 animate-pulse"
      />
    </div>
  );
};

export default LoadingScreen;
